import React from 'react';
import {Flex, Tabs} from "antd";
import MyText from "../../../../components/UI/Text/MyText";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {useDispatch} from "react-redux";
import CertificateList from "./List/CertificateList";
import CertificateTemplateList from "./List/CertificateTemplateList";
import CertificateCreate from "./Creation/CertificateCreate";
import {getAllCertificates, getAllCertificateTemplates} from "../../../../store/slices/CertificateSlice";

const CertificatesPage = () => {
    const dispatch = useDispatch();

    const onChangeTabs = (key) => {
        if (key === '1') {
            dispatch(getAllCertificates({page: 1, limit: 30}));
        }
        if (key === '2') {
            dispatch(getAllCertificateTemplates({page: 1, limit: 30}));
        }
    };

    const tabItems = [
        {
            key: '1',
            label: <IntlMessage id={'certificates'}/>,
            children: <CertificateList/>,
        },
        {
            key: '2',
            label: <IntlMessage id={'certificate.templates'}/>,
            children: <CertificateTemplateList/>,
        },
        {
            key: '3',
            label: <IntlMessage id={'certificate.createCertificate'}/>,
            children: <CertificateCreate/>,
        },
    ]
    return (
        <Flex style={{width: "100%"}} gap={20} align={"flex-start"} justify={"flex-start"} vertical>
            <MyText size={"large"} uppercase strong><IntlMessage id={'certificates'}/></MyText>
            <Tabs destroyInactiveTabPane style={{width: "100%"}} defaultActiveKey={"1"} type="card" items={tabItems}
                  onChange={onChangeTabs}/>
        </Flex>
    );
};

export default CertificatesPage;